import { MarketingNav } from '@/components/layout/marketing-nav'
import { SiteFooter } from '@/components/layout/site-footer'
import { Button } from '@/components/ui/button'
import { getWhitepaperLandingPath, listWhitepapers } from '@/lib/whitepapers'
import { Link } from 'react-router-dom'

export function WhitepapersIndexPage() {
  const whitepapers = listWhitepapers()

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <MarketingNav variant="standalone" />
      <main className="container max-w-5xl px-4 pt-32 pb-16 space-y-10">
        <section className="space-y-3">
          <h1 className="text-4xl font-display font-medium text-gray-900 tracking-[-0.8px]">
            Whitepapers
          </h1>
          <p className="text-gray-600 max-w-2xl">
            Research and insights on workforce transitions, outplacement, and the future of work.
            Enter your details on any report page to receive a download link by email.
          </p>
        </section>

        <section className="grid gap-8 md:grid-cols-2">
          {whitepapers.map((paper) => (
            <article
              key={paper.slug}
              className="flex flex-col rounded-2xl border border-gray-200 bg-white overflow-hidden shadow-sm"
            >
              <div className="aspect-[4/3] overflow-hidden bg-white">
                <img
                  src={`${paper.heroBgSrc}?v=20260602`}
                  alt={paper.coverImageAlt}
                  className="h-full w-full object-cover object-[center_35%]"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-1 flex-col gap-4 p-6">
                <div className="space-y-2">
                  {paper.featured ? (
                    <span className="inline-flex rounded-full bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-700">
                      Latest
                    </span>
                  ) : null}
                  <h2 className="text-xl font-display text-gray-900 leading-snug tracking-[-0.4px]">
                    {paper.title}
                  </h2>
                  <p className="text-sm text-gray-500 leading-relaxed">{paper.shortDescription}</p>
                </div>
                <Button
                  asChild
                  className="mt-auto w-full bg-[#0050e6] hover:bg-[#0050e6]/90 text-white rounded-full"
                >
                  <Link to={getWhitepaperLandingPath(paper.slug)}>Get the whitepaper</Link>
                </Button>
              </div>
            </article>
          ))}
        </section>
      </main>
      <SiteFooter />
    </div>
  )
}
